/** @module csi/widget/MockSizeChartPropertiesChanging  */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"underscore",
	"csi/html",
	"csi/locale",
	"csi/widget/RadioButtonGroup",
	"dojo/text!./MockSizeChartPropertiesChanging.html"

], function(declare,_TemplatedMixin,_WidgetBase,_,html,locale,RadioButtonGroup,template){
	var DEFAULT_CLASSES = "csi-size-chart-mock-table csi-mock-table";
	var ROW_COUNT = 6;
	var RADIO_BUTTON_GROUPS = [
		{
			header: locale.resource("SizeChartMockBaseSizeValues"),
			items: [
				{
					keyText: locale.resource("SizeChartMockBaseSizeValuesMaintain"),
					label: locale.resource("SizeChartMockBaseSizeValuesMaintainLabel"),
					value: "MaintainBaseSize",
					highlightClass: "csi-base-size-maintain"
				},
				{
					keyText: locale.resource("SizeChartMockBaseSizeValuesDiscard"),
					label: locale.resource("SizeChartMockBaseSizeValuesDiscardLabel"),
					value: "DiscardBaseSize",
					highlightClass: "csi-base-size-discard"
				},
			],
			name: "baseSize"
		},
		{
			header: locale.resource("SizeChartMockIncrementValues"),
			items: [
				{
					keyText: locale.resource("SizeChartMockIncrementValuesMaintain"),
					label: locale.resource("SizeChartMockIncrementValuesMaintainLabel"),
					value: "MaintainIncrements",
					highlightClass: "csi-increment-values-maintain"
				},
				{
					keyText: locale.resource("SizeChartMockIncrementValuesReset"),
					label: locale.resource("SizeChartMockIncrementValuesResetLabel"),
					value: "ResetIncrements",
					highlightClass: "csi-increment-values-reset "
				},
			],
			name: "incrementValues"
		},
		{
			header: locale.resource("SizeChartMockTolerances"),
			items: [
				{
					keyText: locale.resource("SizeChartMockTolerancesMaintain"),
					label: locale.resource("SizeChartMockTolerancesMaintainLabel"),
					value: "MaintainTolerances",
					highlightClass: "csi-tolerances-maintain"
				},
				{
					keyText: locale.resource("SizeChartMockTolerancesReset"),
					label: locale.resource("SizeChartMockTolerancesResetLabel"),
					value: "ResetTolerances",
					highlightClass: "csi-tolerances-reset"
				},
			],
			name: "tolerances"
		},
		{
			header: locale.resource("SizeChartMockDimensions"),
			items: [
				{
					keyText: locale.resource("SizeChartMockDimensionsMaintain"),
					label: locale.resource("SizeChartMockDimensionsMaintainLabel"),
					value: "MaintainDimensions",
					highlightClass: "csi-added-dimension-maintain"
				},
				{
					keyText: locale.resource("SizeChartMockDimensionsDiscard"),
					label: locale.resource("SizeChartMockDimensionsDiscardLabel"),
					value: "DiscardDimensions",
					highlightClass: "csi-added-dimension-discard"
				},
			],
			name: "addedDimensions"
		},
	];

	/**
	 * Add class to the table when mouse enter on the radio button group item
	 */
	function _onMouseEnter() {
		var jNode = $(this).closest(".csi-size-chart-mock-table-container").find(".csi-size-chart-mock-table");
		var classesStr = DEFAULT_CLASSES + " " + $(this).data("highlightClass");
		jNode.removeClass();
		jNode.addClass(classesStr);
	}

	/**
	 * Remove class from the table when mouse leave on the radio button group item
	 */
	function _onMouseLeave() {
		$(this).closest(".csi-size-chart-mock-table-container").find(".csi-size-chart-mock-table").removeClass($(this).data("highlightClass"));
	}

	return  declare([_WidgetBase,_TemplatedMixin], {
		templateString: template,
		baseClass: "csi-size-chart-mock-table",
		addedDimensions: locale.resource("SizeChartMockDimensions"),

		/** @property {string[]} excludeGroups - list of properties to exclude */
		excludeGroups: [],

		/**
		 * @override
		 * Render radio buttons group
		 */
		postCreate: function() {
			this.inherited(arguments);
			_.each(RADIO_BUTTON_GROUPS, function(group){
				if (!_.contains(this.excludeGroups, group.name)) {
					this._renderRadioButtonGroup(group);
				}
			}, this);
			this._addTableRows();
		},

		/**
		 * Add radio button group to DOM node
		 * @param {Object} group
		 */
		_renderRadioButtonGroup: function(group) {
			var btnGroup = new RadioButtonGroup(group).placeAt(this.groupNode);
			var jNode = $(btnGroup.domNode);
			jNode.addClass("csi-radio-group-"+group.name);
			jNode.find(".csi-radio-button-group-item").hover(_onMouseEnter, _onMouseLeave);
		},

		/**
		 * Populate the table with additional rows
		 */
		_addTableRows: function() {
			var i = 0;
			var sourceRow = this.contentRowNode;
			while (i < ROW_COUNT) {
				var cloneRow = html.cloneElement(sourceRow);
				sourceRow.parentNode.append(cloneRow);
				i++;
			}
		},

		/**
		 * Click event callback
		 */
		_onClick: function(){
			this.onClick(this.hasResults());
		},

		/**
		 * Extension point for click event handlers
		 */
		onClick: function(){ },

		/**
		 * Return radio group selection and nmber of selections made
		 * @return {Object}
		 */
		hasResults: function() {
			var jNode = $(this.domNode);
			var jChecked = jNode.find(":not(.dijitDisabled).dijitChecked .dijitCheckBoxInput");
			var maintainTolerances = false;
			var maintainDimensions = false;
			var maintainBaseSize = false;
			var maintainIncrements = false;
			_.each(jChecked, function(cb){
				var val = cb.value;
				switch(val){
					case "MaintainBaseSize": maintainBaseSize = true; break;
					case "MaintainIncrements": maintainIncrements = true; break;
					case "MaintainTolerances": maintainTolerances = true; break;
					case "MaintainDimensions": maintainDimensions = true; break;
				}
			})
			return {
				maintainIncrements, // @property {boolean} MaintainIncrements - fasle/true; Maintain Increments radio group selection
				maintainBaseSize, // @property {boolean} MaintainBaseSize - fasle/true; Maintain Base Size radio group selection
				maintainTolerances, // @property {boolean} maintainTolerances - fasle/true; Maintain Tolerance radio group selection
				maintainDimensions  // @property {boolean} maintainDimensions - fasle/true; Maintain Dimensions radio group selection
			}
		}
	});
});